import { DoughnutChart } from '@/ui/charts/doughnut-chart';
import { FlexContainer } from '@/ui/styled-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledMetricsOverlay = styled(FlexContainer)<{ $show: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  border: 1px solid #ebebeb;
  border-radius: 6px;
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  visibility: ${({ $show }) => ($show ? 'visible' : 'hidden')};
  transition: opacity 0.3s ease, visibility 0.3s ease;
  padding: var(--default-padding);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  z-index: 2;

  h4 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #1a1a1a;
  }
`;

const StyledMetricsContainer = styled(FlexContainer)`
  justify-content: center;
  flex-wrap: nowrap;
  flex-direction: row;
  gap: 24px;

  .chart-wrapper {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  label {
    text-align: center;
    font-size: 12px;
    line-height: 1.2;
    color: #1a1a1a;
    font-weight: 400;
  }
`;

type CatalogueCardMetricsProps = {
  clickRate: number | null | undefined;
  submitRate: number | null | undefined;
  visible: boolean;
  campaignId: string;
};

export const CatalogueCardMetrics: React.FC<CatalogueCardMetricsProps> = ({
  clickRate,
  submitRate,
  visible,
  campaignId,
}) => {
  const { t } = useTranslation();

  return (
    <StyledMetricsOverlay $show={visible}>
      <h4>{t('campaign.template.engagementMetrics')}</h4>
      <StyledMetricsContainer>
        {clickRate !== null && clickRate !== undefined && (
          <FlexContainer className="chart-wrapper">
            <DoughnutChart
              allCount={100}
              singleCount={clickRate}
              id={`clicked-${campaignId}`}
              label={t('campaign.clicked')}
              cutout="70%"
              width="100px"
              mainColor="#D84A3F"
              isPercentCount
              isDashboard
              disableInteraction
            />
            <label htmlFor={`clicked-${campaignId}`}>
              {t('campaign.clicked')}
            </label>
          </FlexContainer>
        )}
        {submitRate !== null && submitRate !== undefined && (
          <FlexContainer className="chart-wrapper">
            <DoughnutChart
              allCount={100}
              singleCount={submitRate}
              id={`submitted-${campaignId}`}
              label={t('campaign.submitted')}
              cutout="70%"
              width="100px"
              mainColor="#D84A3F"
              isPercentCount
              isDashboard
              disableInteraction
            />
            <label htmlFor={`submitted-${campaignId}`}>
              {t('campaign.submitted')}
            </label>
          </FlexContainer>
        )}
      </StyledMetricsContainer>
    </StyledMetricsOverlay>
  );
};
